// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__24Kjp","productName":"Table_productName__zZLA1"};